export default "__VITE_ASSET__0RgHZRGW__"